import { writeFileWithDetection, writeFileWithDetectionSync, } from './writeFileWithDetection';
export const writeJsonFile = (path, obj, override) => writeFileWithDetection(path, JSON.stringify(obj, undefined, 2), override);
export const writeJsonFileSync = (path, obj, override) => writeFileWithDetectionSync(path, JSON.stringify(obj, undefined, 2), override);
